'use strict';
import * as $j_java$002eio$002e$002dOutput$002dStream from "./java.io.-Output-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
export { $c_jl_JSConsoleBasedPrintStream$DummyOutputStream as $c_jl_JSConsoleBasedPrintStream$DummyOutputStream };
$p = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = new $j_java$002eio$002e$002dOutput$002dStream.$h_Ljava_io_OutputStream();
$p.constructor = $c_jl_JSConsoleBasedPrintStream$DummyOutputStream;
/** @constructor */
function $h_jl_JSConsoleBasedPrintStream$DummyOutputStream() {
}
export { $h_jl_JSConsoleBasedPrintStream$DummyOutputStream as $h_jl_JSConsoleBasedPrintStream$DummyOutputStream };
$h_jl_JSConsoleBasedPrintStream$DummyOutputStream.prototype = $p;
var $d_jl_JSConsoleBasedPrintStream$DummyOutputStream = new $j_java$002elang$002e$002dObject.$TypeData().i($c_jl_JSConsoleBasedPrintStream$DummyOutputStream, "java.lang.JSConsoleBasedPrintStream$DummyOutputStream", ({
  ke: 1,
  db: 1,
  d9: 1,
  dd: 1,
  da: 1
}));
export { $d_jl_JSConsoleBasedPrintStream$DummyOutputStream as $d_jl_JSConsoleBasedPrintStream$DummyOutputStream };
